module.exports = __webpack_public_path__ + "img/docBlue.6afd378b.svg";